import { Dec, dec, toDecimalString } from './decimal.js';
/**
 * Sensible rounding per unit family. Counts snap to halves, spoons to eighths,
 * small metric amounts keep one decimal, large metric amounts become integers.
 */
export function roundingRuleForUnit(unitCode, value) {
    switch (unitCode) {
        case 'g':
        case 'ml':
        case 'oz':
        case 'floz':
            return value.abs().gte(100) ? { kind: 'integer' } : { kind: 'decimals', places: 1 };
        case 'kg':
        case 'l':
        case 'lb':
            return { kind: 'decimals', places: 3 };
        case 'cl':
        case 'dl':
            return { kind: 'decimals', places: 1 };
        case 'tsp':
        case 'tbsp':
        case 'cup':
            return { kind: 'fraction', denominator: 8 };
        case 'piece':
            return { kind: 'fraction', denominator: 2 };
        case 'cm':
        case 'mm':
        case 'inch':
            return { kind: 'decimals', places: 1 };
        default:
            return value.abs().gte(10) ? { kind: 'integer' } : { kind: 'fraction', denominator: 4 };
    }
}
export function applyRounding(value, rule) {
    switch (rule.kind) {
        case 'integer':
            return value.toDecimalPlaces(0, Dec.ROUND_HALF_UP);
        case 'decimals':
            return value.toDecimalPlaces(rule.places, Dec.ROUND_HALF_UP);
        case 'fraction': {
            const den = dec(rule.denominator);
            return value.times(den).toDecimalPlaces(0, Dec.ROUND_HALF_UP).div(den);
        }
        case 'step': {
            const step = dec(rule.step);
            return value.div(step).toDecimalPlaces(0, Dec.ROUND_HALF_UP).times(step);
        }
    }
}
/**
 * Round a scaled quantity for display. Never rounds when the value is already
 * representable under the rule (so unscaled originals pass through unchanged).
 * Guards against rounding a small positive amount down to zero.
 */
export function roundForDisplay(value, unitCode) {
    const d = dec(value);
    if (d.isZero())
        return '0';
    const rule = roundingRuleForUnit(unitCode, d);
    let rounded = applyRounding(d, rule);
    if (rounded.isZero() && !d.isZero()) {
        // Fall back to a finer rule so "0.1 tsp" does not vanish.
        rounded = d.toDecimalPlaces(2, Dec.ROUND_HALF_UP);
        if (rounded.isZero())
            rounded = d.toDecimalPlaces(3, Dec.ROUND_HALF_UP);
        if (rounded.isZero())
            rounded = d;
    }
    return toDecimalString(rounded);
}
//# sourceMappingURL=rounding.js.map